export default function SectionContact() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto text-center">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
          联系我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500">
          有片源推荐、问题反馈或合作意向？欢迎随时联系
        </p>

        <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-100 border border-background-300/40">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/15">
                <i className="ri-mail-line text-primary-400 text-xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-300">投稿邮箱</span>
              <span className="text-xs text-foreground-500">tougao@mahua.tv</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-500/15">
                <i className="ri-wechat-line text-secondary-400 text-xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-300">官方微信</span>
              <span className="text-xs text-foreground-500">麻花影视官方号</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/15">
                <i className="ri-customer-service-2-line text-accent-400 text-xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-300">在线客服</span>
              <span className="text-xs text-foreground-500">工作日 9:00-21:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}